/**
 * Status (RYG) plus the single plan-vs-actual pair on the graph.
 */

import React from 'react';
import { ANNUAL_RING, GAUGE_FILL } from './types';

interface ColorKeyProps {
  t: (key: string) => string;
  thresholds?: { yellowOffPct: number; redOffPct: number };
}

const STATUS: Array<{ color: string; labelKey: string; fallback: string }> = [
  { color: GAUGE_FILL.GREEN, labelKey: 'kpi.perfKeyOnTrack', fallback: 'On track' },
  { color: GAUGE_FILL.YELLOW, labelKey: 'kpi.perfKeyAtRisk', fallback: 'At risk' },
  { color: GAUGE_FILL.RED, labelKey: 'kpi.perfKeyOffTrack', fallback: 'Off track' }
];

export const ColorKey: React.FC<ColorKeyProps> = ({ t, thresholds }) => (
  <div>
    <h3 className="text-xs font-medium text-[var(--color-surface-text)] mb-1.5">
      {t('kpi.perfColorKey') || 'Color key'}
    </h3>
    {thresholds && (
      <p className="text-[10px] text-[var(--color-secondary-text)] mb-1 leading-tight">
        {t('kpi.thresholdYellow') || 'Yellow at % off'} {thresholds.yellowOffPct}
        {' · '}
        {t('kpi.thresholdRed') || 'Red at % off'} {thresholds.redOffPct}
      </p>
    )}
    <p className="text-[10px] font-medium text-[var(--color-secondary-text)] mb-1">
      {t('kpi.perfKeyStatus') || 'Status'}
    </p>
    <ul className="space-y-1">
      {STATUS.map((item) => (
        <li key={item.labelKey} className="flex items-center gap-1.5 text-[10px] text-[var(--color-surface-text)]">
          <span className="inline-block w-2.5 h-2.5 rounded-sm shrink-0" style={{ backgroundColor: item.color }} />
          <span>{t(item.labelKey) || item.fallback}</span>
        </li>
      ))}
    </ul>
    <p className="text-[10px] font-medium text-[var(--color-secondary-text)] mt-2 mb-1">
      {t('kpi.perfKeyHorizon') || 'On the graph'}
    </p>
    <ul className="space-y-1">
      <li className="flex items-center gap-1.5 text-[10px] text-[var(--color-surface-text)]">
        <span className="inline-block w-2.5 h-2.5 rounded-sm shrink-0" style={{ backgroundColor: 'var(--color-primary-text)' }} />
        <span>{t('kpi.actual') || 'Actual'}</span>
      </li>
      <li className="flex items-center gap-1.5 text-[10px] text-[var(--color-surface-text)]">
        <span className="inline-block w-2.5 h-2.5 rounded-sm shrink-0" style={{ backgroundColor: ANNUAL_RING }} />
        <span>{t('kpi.target') || 'Plan'}</span>
      </li>
    </ul>
  </div>
);
